import "client-only";

import { refreshSessionAuthz } from "@/lib/auth/refresh-session-authz";

/** Refetch session JWT authz and sync NextAuth client context (SessionProvider). */
export const refreshLoginAsSession = async (
  update: () => Promise<unknown>,
): Promise<void> => {
  await refreshSessionAuthz();
  await update();
};
